import AppModal from "../common/AppModal";

export type ScrapperError = {
  errorType: string;
  errorMessage: string;
  url: string;
  createdAt: Date;
};

type ErrorCountModalProps = {
  visibility: boolean;
  errors: ScrapperError[];
  onClose: (T: boolean) => void;
};

function ErrorCountModal({
  visibility,
  errors,
  onClose,
}: ErrorCountModalProps) {
  return (
    <AppModal
      title="Errors Found"
      open={visibility}
      handleClose={() => onClose(false)}
    >
      <div style={{ maxWidth: "100%", overflowX: "hidden" }}>
        {errors?.length === 0 ? (
          <p style={{ margin: 0, textAlign: "center", color: "#6c757d" }}>
            No errors found
          </p>
        ) : (
          <ul
            style={{
              paddingLeft: "20px",
              margin: 0,
              maxHeight: "400px",
              overflowY: "auto",
            }}
          >
            {errors?.map((error, index) => (
              <li key={index} style={{ marginBottom: "12px" }}>
                {/* Error Type */}
                <p
                  style={{
                    color: "red",
                    fontWeight: 500,
                    margin: "0 0 4px 0",
                  }}
                >
                  {error.errorType}
                </p>

                {/* Error Message */}
                <p
                  style={{
                    margin: "0 0 4px 0",
                    wordBreak: "break-word",
                    overflowWrap: "anywhere",
                  }}
                >
                  {error.errorMessage}
                </p>

                {/* URL (clickable + wrapped) */}
                <a
                  href={error.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: "block",
                    fontSize: "12px",
                    color: "#0d6efd",
                    textDecoration: "none",
                    wordBreak: "break-all",
                    marginBottom: "4px",
                  }}
                >
                  {error.url}
                </a>

                {/* Date */}
                <p
                  style={{
                    fontSize: "12px",
                    color: "#6c757d",
                    margin: 0,
                  }}
                >
                  {new Date(error.createdAt).toLocaleString()}
                </p>
              </li>
            ))}
          </ul>
        )}
      </div>
    </AppModal>
  );
}

export { ErrorCountModal };
